import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.js';

const severityIcon = {
  info: 'info',
  success: 'check_circle',
  warn: 'warning',
  error: 'error'
};
function InfoBox(props) {
  const {
    children,
    items,
    severity = 'info',
    iconSize = 'small',
    className,
    style
  } = props;
  const boxClassName = clsx('info-box', severity, className);
  return jsxs("div", {
    className: boxClassName,
    style: style,
    children: [jsx(Icon, {
      className: severity,
      name: severityIcon[severity],
      fontSize: iconSize
    }), jsx("div", {
      className: "flex flex-column gap-2",
      children: items ? items.map((item, index) => jsxs("span", {
        children: [items.length > 1 ? "".concat(index + 1, ". ") : '', item]
      }, index)) : children
    })]
  });
}

export { InfoBox };
